// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.identifier_Ci05A {
  font-size: 12px;
  color : #999999;
  word-break: break-all;
  white-space: normal;
  margin-bottom: 5px;
}

.identifier_Ci05A b {
  padding-right:10px;
}



.apiKeyItem_Ex9jV, .secretItem_Ae5hw {
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;

  }
.apiKeyItem_Ex9jV, .secretItem_Ae5hw label {
  /*margin : 0;
  width : 50px;*/
}

  .apiKey_W2jCj, .secret_Qb58h {
    flex:1;
    text-overflow: ellipsis;
    /*padding : 0 10px;*/
    color : var( --light-grey );
    min-width:0;
  }
  .apiKeyItem_Ex9jV > button, .secretItem_Ae5hw > button {
    flex : 0
  }

  .customNetworkDialog_bAtg3 {
    width : 400px;
  }`, "",{"version":3,"sources":["webpack://./src/editors/network/style.css"],"names":[],"mappings":"AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;;;AAIA;IACI,cAAc;IACd,oBAAoB;IACpB,+BAA+B;IAC/B,oBAAoB;;EAEtB;AACF;EACE;gBACc;AAChB;;EAEE;IACE,MAAM;IACN,uBAAuB;IACvB,oBAAoB;IACpB,2BAA2B;IAC3B,WAAW;EACb;EACA;IACE;EACF;;EAEA;IACE,aAAa;EACf","sourcesContent":["@import \"../../style/theme.css\";\n\n.identifier {\n  font-size: 12px;\n  color : #999999;\n  word-break: break-all;\n  white-space: normal;\n  margin-bottom: 5px;\n}\n\n.identifier b {\n  padding-right:10px;\n}\n\n\n\n.apiKeyItem, .secretItem {\n    display : flex;\n    flex-direction : row;\n    justify-content : space-between;\n    align-items : center;\n\n  }\n.apiKeyItem, .secretItem label {\n  /*margin : 0;\n  width : 50px;*/\n}\n\n  .apiKey, .secret {\n    flex:1;\n    text-overflow: ellipsis;\n    /*padding : 0 10px;*/\n    color : var( --light-grey );\n    min-width:0;\n  }\n  .apiKeyItem > button, .secretItem > button {\n    flex : 0\n  }\n\n  .customNetworkDialog {\n    width : 400px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"identifier": `identifier_Ci05A`,
	"apiKeyItem": `apiKeyItem_Ex9jV`,
	"secretItem": `secretItem_Ae5hw`,
	"apiKey": `apiKey_W2jCj`,
	"secret": `secret_Qb58h`,
	"customNetworkDialog": `customNetworkDialog_bAtg3`
};
export default ___CSS_LOADER_EXPORT___;
